(function () {
  'use strict';

  var QR_PATH = '/pages/welcome-to-weathercraft';
  var QR_LINKS = [
    { label: 'Find Your Wine', href: '#find-your-wine' },
    { label: 'Shop Current Releases', href: '/pages/wines' },
    { label: 'Meet Weathercraft', href: '#people' },
    { label: 'Visit the Vineyard', href: '#vineyard' }
  ];

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      /* Storage may be unavailable in strict privacy modes. */
    }
  }

  function normalisedPath() {
    return window.location.pathname.replace(/\/$/, '') || '/';
  }

  function isQrPage() {
    return normalisedPath() === QR_PATH;
  }

  function establishInternalTestFlag() {
    var params = new URLSearchParams(window.location.search);
    var isTest = params.get('utm_source') === 'internal_test' || params.get('wc_test') === '1';
    if (isTest) safeSet(window.sessionStorage, 'wc_internal_test', 'true');
  }

  function trafficType() {
    return safeGet(window.sessionStorage, 'wc_internal_test') === 'true' ? 'internal_test' : 'customer';
  }

  function emit(eventName, parameters) {
    var payload = Object.assign(
      {
        page_path: normalisedPath(),
        page_title: document.title,
        traffic_type: trafficType()
      },
      parameters || {}
    );

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }

    document.dispatchEvent(
      new CustomEvent('wc:analytics', {
        detail: { event: eventName, parameters: payload }
      })
    );
  }

  function persistQrAttribution() {
    var attribution = {
      source: 'bottle_qr',
      medium: 'packaging',
      campaign: 'back_label',
      landing_page: QR_PATH,
      captured_at: new Date().toISOString()
    };

    safeSet(window.sessionStorage, 'wc_acquisition', JSON.stringify(attribution));
    safeSet(window.localStorage, 'wc_acquisition', JSON.stringify(attribution));
    document.cookie = 'wc_acquisition_source=bottle_qr; Max-Age=2592000; Path=/; SameSite=Lax';

    if (safeGet(window.sessionStorage, 'wc_qr_landing_emitted') !== 'true') {
      emit('wc_bottle_qr_landing', {
        acquisition_source: attribution.source,
        acquisition_medium: attribution.medium,
        acquisition_campaign: attribution.campaign
      });
      safeSet(window.sessionStorage, 'wc_qr_landing_emitted', 'true');
    }
  }

  function setFindWineAnchor() {
    var headings = Array.from(document.querySelectorAll('h1, h2, h3'));
    var heading = headings.find(function (item) {
      return item.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === 'find the wine you just enjoyed';
    });

    if (!heading) return;
    heading.id = 'find-your-wine';
    heading.style.scrollMarginTop = 'calc(var(--header-height, 80px) + 28px)';
  }

  function buildLinkList(list) {
    list.innerHTML = '';
    QR_LINKS.forEach(function (item) {
      var li = document.createElement('li');
      var link = document.createElement('a');
      link.href = item.href;
      link.textContent = item.label;
      link.dataset.wcQrNavigation = item.label;
      li.appendChild(link);
      list.appendChild(li);
    });
  }

  function replaceQrDesktopIndex() {
    document.querySelectorAll('[data-wc-h2-index] h2, [data-wc-h2-index-sticky] h2').forEach(function (heading) {
      heading.textContent = 'Start Here';
    });

    document.querySelectorAll('[data-wc-h2-index-list]').forEach(buildLinkList);
  }

  function addQrMobileStartMenu() {
    if (document.getElementById('wc-qr-start')) return;
    var hero = document.querySelector('[data-wc-indexed-hero]');
    if (!hero) return;

    var nav = document.createElement('nav');
    nav.id = 'wc-qr-start';
    nav.className = 'wc-qr-start';
    nav.setAttribute('aria-label', 'Start here');

    var inner = document.createElement('div');
    inner.className = 'wc-qr-start__inner';

    var label = document.createElement('p');
    label.className = 'wc-qr-start__label';
    label.textContent = 'Start Here';

    var links = document.createElement('div');
    links.className = 'wc-qr-start__links';

    QR_LINKS.forEach(function (item) {
      var link = document.createElement('a');
      link.href = item.href;
      link.textContent = item.label;
      link.dataset.wcQrNavigation = item.label;
      links.appendChild(link);
    });

    inner.appendChild(label);
    inner.appendChild(links);
    nav.appendChild(inner);

    var section = hero.closest('.shopify-section');
    (section || hero).insertAdjacentElement('afterend', nav);
  }

  function formType(form) {
    if (form.classList.contains('wc-contact-wholesale__form')) return 'wholesale_enquiry';
    if (form.classList.contains('wc-contact-page-form__form')) return 'contact_enquiry';
    return 'other_form';
  }

  function detectSuccessfulForms() {
    var success = document.querySelector('.wc-form-status--success, .wc-contact-page-form__success');
    if (!success) return;
    var key = 'wc_form_success_' + normalisedPath();
    if (safeGet(window.sessionStorage, key) === 'true') return;

    var form = success.closest('form');
    emit('wc_form_submit_success', { form_type: form ? formType(form) : 'unknown_form' });
    safeSet(window.sessionStorage, key, 'true');
  }

  function handleClick(event) {
    var target = event.target.closest('a, button');
    if (!target) return;

    var pathway = target.closest('.wc-customer-pathways__link');
    if (pathway) {
      var pathwayTitle = pathway.querySelector('.wc-customer-pathways__link-title');
      emit('wc_homepage_pathway_click', {
        pathway: pathwayTitle ? pathwayTitle.textContent.trim() : pathway.textContent.trim(),
        link_url: pathway.href || ''
      });
    }

    var blockedCheckout = target.closest('button[name="checkout"][aria-disabled="true"], [data-wc-checkout-disabled="true"]');
    if (blockedCheckout) {
      emit('wc_cart_validation_blocked', { validation_rule: 'wine_quantity_multiple_of_three' });
    }

    if (!isQrPage()) return;

    var qrNav = target.closest('[data-wc-qr-navigation]');
    if (qrNav) {
      emit('wc_bottle_qr_navigation', {
        destination: qrNav.dataset.wcQrNavigation || qrNav.textContent.trim(),
        link_url: qrNav.href || ''
      });
      return;
    }

    var link = target.closest('a');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (href.indexOf('/products/') !== -1 || href.indexOf('/wine/') !== -1) {
      emit('wc_bottle_qr_product_click', {
        link_text: link.textContent.replace(/\s+/g, ' ').trim(),
        link_url: link.href
      });
    } else if (href.indexOf('/pages/wines') !== -1) {
      emit('wc_bottle_qr_shop_click', { link_url: link.href });
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.wc-contact-wholesale__form, .wc-contact-page-form__form')) return;
    emit('wc_form_submit_attempt', { form_type: formType(form) });
  }

  function initialise() {
    establishInternalTestFlag();

    if (isQrPage()) {
      setFindWineAnchor();
      replaceQrDesktopIndex();
      addQrMobileStartMenu();
      persistQrAttribution();
    }

    detectSuccessfulForms();
    document.addEventListener('click', handleClick);
    document.addEventListener('submit', handleSubmit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }

  window.WeathercraftPhase2Analytics = {
    emit: emit,
    isQrPage: isQrPage,
    trafficType: trafficType
  };
})();
